let configureStore = null;

if (process.env.NODE_ENV === "production") {
  configureStore = require("./configureStore.prod").default; // tslint:disable-line
} else {
  configureStore = require("./configureStore.dev").default; // tslint:disable-line
}

export default configureStore;

// Using require instead of import becasue ES6 doesn't support dynamic imports.
